// extracted by mini-css-extract-plugin
module.exports = {"wknqxok":"wknqxok","c1x2absh":"c1x2absh","cwkximy":"cwkximy","cpjbl5r":"cpjbl5r"};